import React, { useContext, useEffect, useState } from "react";
import "../styles/projectSetup.css";
import { useParams } from "react-router-dom";
import ProfileDetailsTab from "../components/ProjectSetup/ProfileDetailsTab";
import ProjectDetailsTab from "../components/ProjectSetup/ProjectDetailsTab";
import ScreeningQuestionsTab from "../components/ProjectSetup/ScreeningQuestionsTab";
import ReviewTab from "../components/ProjectSetup/ReviewTab";
import DatabaseResult from "../components/ProjectDetails/DatabaseResult";
import LoadingIcon from "../images/Loading_icon.gif";

import { UrlContext } from "../contexts/UrlContext";

export default function ProjectSetup() {
  useEffect(() => {
    document.title = "Project Setup";
  }, []);
  const id = useParams().id;
  const { API_URL } = useContext(UrlContext);
  const [experts, setExperts] = useState([]);
  const [project_id, setProject_id] = useState("");
  const [activeTab, setActiveTab] = useState("projectDetails");
  const [languages, setLanguages] = useState([]);
  const [skills, setSkills] = useState([]);
  const [projCategory, setProjCategory] = useState([]);
  const [projEditing, setProjEditing] = useState(false);
  const [owners, setOwners] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [skillValue, setSkillValue] = useState('')
  const [loadingPopup, setLoadingPopup] = useState(false)
  const [profileTypeSelected, setProfileTypeSelected] = useState(false)
  const [startDateSelected, setStartDateSelected] = useState(false)
  const [deadlineSelected, setDeadlineSelected] = useState(false)
  const [spacialLanguages, setSpacialLanguages] = useState([
    {
      code: "ar",
      name: "Arabic",
      type: "Mostly used",
    },
    {
      code: "zh",
      name: "Chinese",
      type: "Mostly used",
    },
    {
      code: "en",
      name: "English",
      type: "Mostly used",
    },
    {
      code: "fr",
      name: "French",
      type: "Mostly used",
    },
    {
      code: "de",
      name: "German",
      type: "Mostly used",
    },
    {
      code: "pt",
      name: "Portuguese",
      type: "Mostly used",
    },
    {
      code: "es",
      name: "Spanish",
      type: "Mostly used",
    },
  ]);

  const [data, setData] = useState({
    leadEmail: "",
    additionalEmails: [],
    projectName: "",
    projectDescription: "",
    projectRegion: "",
    projectLocation: "",
    projectConsultantType: "",
    projectIndustyPreference: "No",
    projectIndustyPreferenceList: "",
    projectDailyBudget: "",
    projectCategory: "",
    projectSkillsRequirements: [],
    projectSuggestedSkills: [],
    projectLanguages: [],
    projectSeniority: [],
    projectStartDateOption: "",
    projectStartDate: "",
    projectDuration: "",
    projectTypeOfEmployment: "",
    projectRemoteOption: "",
    projectOnsiteOption: "",
    clientOwner: "",
    projectDeadline: "",
    utilizationIntensity: "100",
    totalDays: "",
    screeningQuestions: [],
    public: false,
    proposal: false,
    company: [],
  });
  const [screeningQuestion, setScreeningQuestion] = useState([
    { questionNumber: 1, question: "", answerType: 'Open-Ended', focus: false, options: [] },
  ]);
  const [options, setOptions] = useState([])
  const [proposalType, setProposalType] = useState(false)


  useEffect(() => {
    const url = `${API_URL}project-setup-data`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setLanguages(data.language);

        let newSkills = [];
        data.skillList.forEach((skill) => {
          newSkills.push({ label: skill, value: skill });
        });
        setSkills(newSkills);

        let newProjCategory = data.projCategory;
        let Data_and_Business_Analytics =
          newProjCategory["Data & Business Analytics"];
        const skills = Object.keys(
          Data_and_Business_Analytics["Big Data & Analytics"][0]
        ).map((skill) => {
          return Data_and_Business_Analytics["Big Data & Analytics"][0][skill];
        });
        Data_and_Business_Analytics["skills"] = skills;
        newProjCategory["Data & Business Analytics"] =
          Data_and_Business_Analytics;
        setProjCategory(newProjCategory);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if(id){
      setLoadingPopup(true)
      console.log('here from info', id)
      const url = `${API_URL}get-project-data/` + id;
      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setLoadingPopup(false)
          console.log(data.projectInfo, data.owners);
          setData(data.projectInfo);
          setProjEditing(true)
          setOwners(data.owners)
          setSkillValue(data.skills)
          if(data.projectInfo.projectConsultantType){
            setProfileTypeSelected(true)
          }
          if(data.projectInfo.projectStartDate){
            setStartDateSelected(true)
          }
          if(data.projectInfo.projectDeadline){
            setDeadlineSelected(true)
          }
          if(data.projectInfo.screeningQuestions){
            setScreeningQuestion(data.projectInfo.screeningQuestions)
          }
          setProposalType(data.projectInfo.proposal)
        })
        .catch((err) => console.log(err));
      }
  }, [id])

  return (
    <>
      {experts.length ? (
        <DatabaseResult searchResults={experts} projectId={project_id} />
      ) : (
        <div className="container-fluid">
          <div className="row m-justify-content-center">
            <div className="prj-setup-container col-xl-8 text-center mb-2">
              <div className="card px-0 pt-4 pb-0 mb-3">
                <h2 id="prjsetup-heading">{projEditing ? "Project Update" : "Project Setup"}</h2>
                <div id="project-setup-form">
                  <ul id="progressbar">
                    <li className="active" id="account">
                      <strong>Project Details</strong>
                    </li>
                    <li
                      className={
                        activeTab === "profileDetails" || activeTab === "finish"
                          ? "active"
                          : ""
                      }
                      id="personal"
                    >
                      <strong>Profile Details</strong>
                    </li>
                    <li
                      className={activeTab === "finish" ? "active" : ""}
                      id="confirm"
                    >
                      <strong>Review</strong>
                    </li>
                  </ul>
                  <div
                    className={activeTab === "projectDetails" ? "" : "d-none"}
                  >
                    <ProjectDetailsTab
                      setActiveTab={setActiveTab}
                      data={data}
                      setData={setData}
                      projCategory={projCategory}
                      owners={owners}
                      setOwners={setOwners}
                      companies={companies}
                      setCompanies={setCompanies}
                      projEditing={projEditing}
                      profileTypeSelected={profileTypeSelected}
                      setProfileTypeSelected={setProfileTypeSelected}
                      proposalType={proposalType}
                      setProposalType={setProposalType}
                    />
                  </div>
                  <div
                    className={activeTab === "profileDetails" ? "" : "d-none"}
                  >
                    <ProfileDetailsTab
                      spacialLanguages={spacialLanguages}
                      setActiveTab={setActiveTab}
                      data={data}
                      setData={setData}
                      projCategory={projCategory}
                      skills={skills}
                      setSkills={setSkills}
                      languages={languages}
                      skillValue={skillValue}
                      setSkillValue={setSkillValue}
                      startDateSelected={startDateSelected}
                      setStartDateSelected={setStartDateSelected}
                      deadlineSelected={deadlineSelected}
                      setDeadlineSelected={setDeadlineSelected}
                      screeningQuestion={screeningQuestion}
                      setScreeningQuestion={setScreeningQuestion}
                      options={options}
                      setOptions={setOptions}
                    />
                  </div>
                  <div className={activeTab === "finish" ? "" : "d-none"}>
                    <ReviewTab
                      setActiveTab={setActiveTab}
                      data={data}
                      setExperts={setExperts}
                      setProject_id={setProject_id}
                      projEditing={projEditing}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loadingPopup && (
            <div className="linkedin-popup-wrapper">
              <div className="tab-pane fade show linkedin-div">
                <center>
                  <p style={{ fontSize: "18px" }}>Loading...</p>
                  <br />
                  <img
                    src={LoadingIcon}
                    alt=""
                    style={{ width: "50px", marginRight: "5px" }}
                  />
                </center>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
